import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../../AuthContext/AuthContext';
// import ReminderAlert from '../Admin/Potentialleads/ReminderAlert'; 

const ProtectedRoute = () => {
  const { authToken } = useContext(AuthContext);

  if (!authToken) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {/* <ReminderAlert />    */}
      <Outlet />
    </>
  );
};

export default ProtectedRoute;